import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import rest from '../axios';
import './css/estatisticas.css';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const EstatisticasComponent = () => {
  const [estatisticas, setEstatisticas] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    rest.get('admin/statistics')
      .then((response) => {
        setEstatisticas(response.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar estatísticas:', error);
        setLoading(false);
      });
  }, []);

  const chartOptions = {
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  };

  // Função para gerar o gráfico
  const generateChartData = (label, data, backgroundColor) => ({
    labels: [label],
    datasets: [
      {
        label: label,
        data: [data],
        backgroundColor,
        borderColor: backgroundColor,
        borderWidth: 1,
      },
    ],
  });

  return (
    <div className="containeri">
      <h1>Estatísticas do Sistema</h1>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <div className="table-wrapper">
            <div className="row">
              {/* Gráfico de número de usuários */}
              <div className="col-md-4">
                <h3>Número de Usuários</h3>
                <Bar
                  data={generateChartData('Usuários', estatisticas.usersCount, 'rgba(54, 162, 235, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.usersCount} Usuários</p>
              </div>

              {/* Gráfico de número de prestadores */}
              <div className="col-md-4">
                <h3>Número de Prestadores</h3>
                <Bar
                  data={generateChartData('Prestadores', estatisticas.providersCount, 'rgba(75, 192, 192, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.providersCount} Prestadores</p>
              </div>

              {/* Gráfico de número de comentários */}
              <div className="col-md-4">
                <h3>Número de Comentários</h3>
                <Bar
                  data={generateChartData('Comentários', estatisticas.commentsCount, 'rgba(255, 99, 132, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.commentsCount} Comentários</p>
              </div>
            </div>

            <div className="row mt-5">
              {/* Gráfico de número de avaliações */}
              <div className="col-md-4">
                <h3>Número de Avaliações</h3>
                <Bar
                  data={generateChartData('Avaliações', estatisticas.ratingsCount, 'rgba(153, 102, 255, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.ratingsCount} Avaliações</p>
              </div>

              {/* Gráfico de número de categorias */}
              <div className="col-md-4">
                <h3>Número de Categorias</h3>
                <Bar
                  data={generateChartData('Categorias', estatisticas.categoriesCount, 'rgba(255, 159, 64, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.categoriesCount} Categorias</p>
              </div>

              {/* Gráfico de número de subcategorias */}
              <div className="col-md-4">
                <h3>Número de Subcategorias</h3>
                <Bar
                  data={generateChartData('Subcategorias', estatisticas.subcategoriesCount, 'rgba(255, 205, 86, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.subcategoriesCount} Subcategorias</p>
              </div>
            </div>

            <div className="row mt-5">
              {/* Gráfico de número de condomínios */}
              <div className="col-md-4">
                <h3>Número de Condomínios</h3>
                <Bar
                  data={generateChartData('Condomínios', estatisticas.condominiumsCount, 'rgba(153, 159, 255, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.condominiumsCount} Condomínios</p>
              </div>

              {/* Gráfico de número de bairros */}
              <div className="col-md-4">
                <h3>Número de Bairros</h3>
                <Bar
                  data={generateChartData('Bairros', estatisticas.neighborhoodsCount, 'rgba(255, 105, 180, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.neighborhoodsCount} Bairros</p>
              </div>

              {/* Gráfico de número de cidades */}
              <div className="col-md-4">
                <h3>Número de Cidades</h3>
                <Bar
                  data={generateChartData('Cidades', estatisticas.citiesCount, 'rgba(255, 165, 0, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.citiesCount} Cidades</p>
              </div>
            </div>

            <div className="row mt-5">
              {/* Gráfico de usuários comuns */}
              <div className="col-md-4">
                <h3>Usuários Comuns</h3>
                <Bar
                  data={generateChartData('Usuários Comuns', estatisticas.commonUsersCount, 'rgba(255, 159, 64, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.commonUsersCount} Usuários Comuns</p>
              </div>

              {/* Gráfico de administradores */}
              <div className="col-md-4">
                <h3>Administradores</h3>
                <Bar
                  data={generateChartData('Administradores', estatisticas.adminUsersCount, 'rgba(75, 192, 192, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.adminUsersCount} Administradores</p>
              </div>

              {/* Gráfico de prestadores */}
              <div className="col-md-4">
                <h3>Prestadores de Serviço</h3>
                <Bar
                  data={generateChartData('Prestadores de Serviço', estatisticas.providerUsersCount, 'rgba(153, 102, 255, 0.2)')}
                  options={chartOptions}
                />
                <p className="text-center mt-2">{estatisticas.providerUsersCount} Prestadores</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EstatisticasComponent;
